import React from "react";
import PropTypes from "prop-types";
import { Slot } from "./Slot";

import "./style.scss";

export function InteractionArea(props) {
  const [tubePickedUp, setTubePickedUp] = React.useState(false);
  const [pickedUpTubeId, setPickedUpTubeId] = React.useState(null);

  const renderSlot = (slot) => {
    const className = `mc_slot  slotpos--${slot.id}`;
    return (
      <Slot
        className={className}
        {...slot}
        onDrop={props.onDrop}
        pickedUpTubeId={pickedUpTubeId}
        tubePickedUp={tubePickedUp}
        setPickedUpTubeId={setPickedUpTubeId}
        setTubePickedUp={setTubePickedUp}
      />
    );
  };
  return <div className={props.className}>{props.slots.map(renderSlot)}</div>;
}

InteractionArea.propTypes = {
  /**
   * data of all slots
   * slot position start from 1 to 12 ; 1 being at' 12 0 clock' position and so on
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * id of slot
       */
      id: PropTypes.number,
      /**
       * specifies if rotor is present
       */
      rotor: PropTypes.bool,
      /**
       * specifes if solution is present
       */
      tube: PropTypes.bool,
    })
  ),
  /**
   * callback function to trigger on drop
   */
  onDrop: PropTypes.func,
  /**
   * className
   */
  className: PropTypes.string,
};

InteractionArea.defaultProps = {
  slots: [
    { id: 1, rotor: false, tube: false },
    { id: 2, rotor: false, tube: false },
    { id: 3, rotor: false, tube: false },
    { id: 4, rotor: false, tube: false },
    { id: 5, rotor: false, tube: false },
    { id: 6, rotor: false, tube: false },
    { id: 7, rotor: false, tube: false },
    { id: 8, rotor: false, tube: false },
    { id: 9, rotor: false, tube: false },
    { id: 10, rotor: false, tube: false },
    { id: 11, rotor: false, tube: false },
    { id: 12, rotor: false, tube: false },
  ],
};
